export default {
    firebaseConfig: {
        apiKey: 'AIzaSyA4Q_NWqw-_NVr5oNz6CzRu8fKv_J-0gLI',
        authDomain: 'music-sheet-20e93.firebaseapp.com',
        databaseURL: 'https://music-sheet-20e93.firebaseio.com',
        projectId: 'music-sheet-20e93',
        storageBucket: 'music-sheet-20e93.appspot.com',
        messagingSenderId: '1065315460721',
    },
    uploadFileMaxByte: 5000000,
    defaultSpeed: 60,
    defaultBeatPerline: 12,
    defaultCountDownBeats: 4,
};



// WEBPACK FOOTER //
// ./src/js/variable.js